import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../../lib/types';

export const scope = 'app.components.CheckIn';

export const getMessages = (termLookup: SportTermLookup) => {
  const athlete = termLookup[SportTerminology.ATHLETE].toLowerCase();
  return defineMessages({
    errChangeNotSaved: {
      id: `${scope}.errChangeNotSaved`,
      defaultMessage: "That change wasn't saved. Please try again."
    },
    errJerseyNotSaved: {
      id: `${scope}.errJerseyNotSaved`,
      defaultMessage: "The jersey wasn't assigned. Please try again."
    },
    errJerseyNotificationNotSent: {
      id: `${scope}.errJerseyNotificationNotSent`,
      defaultMessage: "The jersey was assigned, but the notification to parents wasn't sent. Please try again."
    },
    errCheckOutNotSaved: {
      id: `${scope}.errCheckOutNotSaved`,
      defaultMessage: `The ${athlete} wasn't checked out. Please try again.`
    },
    errRosterNotSaved: {
      id: `${scope}.errRosterNotSaved`,
      defaultMessage: `The ${athlete} list wasn't updated. Please try again.`
    },
    errTeamsNotSaved: {
      id: `${scope}.errTeamsNotSaved`,
      defaultMessage: "The teams weren't saved. Please try again."
    },
    errPositionNotSaved: {
      id: `${scope}.errPositionNotSaved`,
      defaultMessage: "The position wasn't changed. Please try again."
    },
  });
};
